<template>
 <div class="xm-step">
    <div class="step-section" style="margin-bottom: 20px; ">
        <div class="step-title-wrap">
            <div class="step-title step-title-blue">手动一键打包流程</div>
        </div>
        <div class="xm-step-content">
            <div class="step-item step-item-blue">
                <div class="step-num step-num-blue">1</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">一键打包</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">待处理订单为未提交仓库打包订单</div>
                </div>
            </div>
            <div class="step-item step-item-blue">
                <div class="step-num step-num-blue">2</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">填写信息</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">填写上家发货单号或选择库存打包</div>
                </div>
            </div>
            <div class="step-item step-item-blue">
                <div class="step-num step-num-blue">3</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">提交打包</span>
                    </div>
                    <div class="step-item-desc">提交打包后在已打包订单页面查看</div>
                </div>
            </div>
        </div>
    </div>
    <div class="step-section" style="border-top: 1px solid #f5f5f5; padding-top: 20px;">
        <div class="step-title-wrap">
            <div class="step-title step-title-purple">
                插件采购打包流程
            </div>
        </div>
        <div class="xm-step-content">
            <div class="step-item step-item-purple">
                <div class="step-num step-num-purple">1</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">安装插件</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">
                        <div style="margin: 5px 0px;">检测插件： <span style="color: #ff4a57;">{{isInstall?'已安装':'未安装'}}</span></div>
                        <el-button plain size="mini" style="background: transparent;" @click="downloadPlugin">下载插件20261021</el-button>
                        <el-link href="https://www.kdocs.cn/l/chH4yozYMPhY" target="_blank" type="warning" style="margin-left:5px;">
                            <!-- <icon-svg icon-class="icon-tishi2" style="margin-top:7px;" font-size="20px;"/> -->
                            帮助
                        </el-link>
                    </div>
                </div>
            </div>
            <div class="step-item step-item-purple">
                <div class="step-num step-num-purple">2</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">一键采购</span>
                        <span class="step-line"></span>
                    </div>
                    <div class="step-item-desc">
                        <div style="margin: 5px 0px;">关联货源即可一键采购发货</div>
                        <div style="display: flex; align-items: center;">
                            <div class="step-item-desc-link">
                                <i class="iconfont">&#xe603;</i>
                                <a href="https://mobile.yangkeduo.com/login.html" target="_blank">去登录</a>
                            </div>
                            <div class="step-item-desc-link" style="margin: 0px 10px;">
                                <i class="iconfont" >&#xe786;</i>
                                <a href="https://login.taobao.com/member/login.jhtml" target="_blank">去登录</a>
                            </div>
                            <div class="step-item-desc-link">
                                <i class="iconfont">&#xe60f;</i>
                                <a href="https://login.1688.com" target="_blank">去登录</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step-item step-item-purple">
                <div class="step-num step-num-purple">3</div>
                <div class="step-item-content">
                    <div class="step-item-title-wrap">
                        <span class="step-item-title">自动打包</span>
                    </div>
                    <div class="step-item-desc">请采购账号保持<span>登录状态</span>(1688授权即可),系统自动同步发货单号提交打包</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isInstall: false,
        }
    },
    mounted: function(){
        this.checkInstall();
    },
    methods: {
        downloadPlugin() {
            window.open(this.$kit.api.chromeDownload1+"?t="+new Date().getTime(),"_blank")
        },
        checkInstall() {
            setTimeout(() => {
                let extId = document.body.getAttribute('ba-ext-id');
                if (extId) {
                    this.isInstall = true;
                }else{
                    this.isInstall = false;
                }
            }, 2000);
        }

    }
}
</script>

<style scoped>
.xm-step {
    padding: 30px 20px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
}

.step-section {
    display: flex;
    align-items: center;
    gap: 40px;
}

.step-title-wrap {
    display: flex;
    align-items: center;
    height: 100%;
}

.step-title {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 12px 20px;
    color: white;
    font-weight: bold;
    font-size: 14px;
    position: relative;
    min-width: 0;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    line-height: 1;
}

.step-title::after {
    content: '';
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 20px solid #597ef7;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
}

.step-title-blue::after {
    border-left-color: #597ef7;
}

.step-title-purple::after {
    border-left-color: #722ed1;
}

.step-title-blue {
    background: #597ef7;
}

.step-title-purple {
    background: #722ed1;
    color: white;
}

.xm-step-content {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 60px;
    flex: 1;
    height: auto;
}

.step-item {
    display: flex;
    align-items: flex-start;
    position: relative;
    flex: 1;
}


.step-item-title-wrap {
    display: flex;
    align-items: center;
}

.step-item-title {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.step-line {
    display: inline-block;
    height: 0;
    border-top: 1px dashed #597ef7;
    margin-left: 8px;
    flex: 1;
    position: relative;
    left:45px;
}

.step-item-purple .step-line {
    border-top-color: #722ed1;
}

.step-num {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
    margin-right: 15px;
    flex-shrink: 0;
    z-index: 1;
}

.step-num-blue {
    background: #597ef7;
}

.step-num-purple {
    background: #722ed1;
    color: white;
}

.step-item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.step-item-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}


.step-item-desc a {
    color: #409eff;
    text-decoration: none;
}

.step-item-desc a:hover {
    text-decoration: underline;
}

.step-item-desc-link{
    display: flex;
    align-items: center;
}

.step-item-desc-link i{
    font-size: 25px;
    margin-right: 5px;
}


</style>

